// @flow

export default (props) => {
	switch (props.decorator || props.is) {
		case 'ProductListSlider':
			return import('fg-frontend/components/ProductListSlider');
		case 'EshopPhotogallery':
			return import('./components/EshopPhotogallery');
		case 'EshopModel3D':
			return import('fg-frontend/components/EshopModel3D');
    case 'EshopImageZoom':
      return import('./components/EshopImageZoom');
/*		case 'EshopImageMagnify':
			return import('fg-frontend/components/EshopImageMagnify');*/
		case 'EshopGalleryPopup':
			return import('fg-frontend/components/EshopGalleryPopup');
		case 'EshopOrderForm':
			return import('fg-frontend/components/EshopOrderForm');
		case 'BtnVariant':
			return import('./components/BtnVariant');
    case 'UnorderableHandler':
      return import('./components/UnorderableHandler');
    case 'StickyHandler':
      return import('./components/StickyHandler');
    case 'BtnBadgeCount':
      return import('./components/BtnBadgeCount');
		case 'EshopFulltextAutocomplete':
			return import('./components/EshopFulltextAutocomplete');
		// eshop - detail produktu - komponenta productDetailVariantForm - odkomentovat, pokud je na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>
		case 'EshopVariantStockHandler':
			return import('fg-frontend/src/components/EshopVariantStockHandler');
		case 'EshopUserToolsHandler':
			return import('./components/EshopUserToolsHandler');
    case 'EshopHeader':
      return import('./components/EshopHeader');
    case 'FilterHandler':
      // CUSTOMIZACE: Handler pro zobrazeni poctu aktualne zaskrtnutych komponent ve filtru
      return import('./components/FilterHandler');
    case 'ScrollHandler':
      return import('./components/ScrollHandler');
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js